import { Wrapper } from '../wrapper';
import { ConversationItem, type MessagesSidebarItemConversationProperties } from './conversation-item';
import { NewMessageItem } from './new-message-item';

export type MessagesSidebarItemProperties =
  | ({ type: 'conversation' } & MessagesSidebarItemConversationProperties)
  | { type: 'new' };

const MessagesSidebarItem = (properties: MessagesSidebarItemProperties) => {
  const { type } = properties;

  return (
    <Wrapper paddingHorizontal="xs" paddingVertical="xxxs">
      {type === 'conversation' ? <ConversationItem {...properties} /> : <NewMessageItem />}
    </Wrapper>
  );
};

export default MessagesSidebarItem;
